import { useSnackbar } from "src/utils/hook/base/baseserviceindex";
import useAAA from "./useAAA";
import { Navigate } from "react-router-dom";

const useErrorHandling = () => {
  const { clearUserData } = useAAA();
    const { snack } = useSnackbar();
  const errorHandling =(error) => {
    if (error?.graphQLErrors)
      { if ((error?.graphQLErrors[0]?.status_code ===1430 || error?.graphQLErrors[0]?.status_code ===1401) && process.env.REACT_APP_ENVIROMENT_DEPLOYMENT!=="DEV")
    {
      clearUserData(); 
      Navigate("/login");
      return null
    }}


    if(error?.ORC && (!(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST"))){
      snack.error({
        title: "خطا در درگاه سرویس",
      });
    }

    // if (error?.graphQLErrors?.length && (!(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST")))
    //   {snack.error({
    //     title: "خطا در درگاه سرویس",
    //   });
    // }

     if (error?.graphQLErrors?.length)
      {snack.error({
        title: error?.message,
      });
    }


    if (error?.protocolErrors?.length && (!(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST")))
      {snack.error({
        title: "خطا در قوانین درگاه",
      });
    }

    if (error?.clientErrors?.length && (!(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST")))
      {snack.error({
        title: "خطا کاربری",
      });
    }

    if (error?.networkError && (!(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST")))
     { snack.error({
        title: "خطا ارتباط با سامانه",
      });
    }

    if(process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="DEV" || process.env.REACT_APP_ENVIROMENT_DEPLOYMENT==="TEST")
    {if (error?.message?.length)
      snack.error({
        title: error?.message,
      });
    if (error?.extraInfo)
      snack.error({
        title: error?.extraInfo,
      });
    }
  }

  return { errorHandling };
};

export default useErrorHandling;